import { render, staticRenderFns } from "./EmployeePolicy.vue?vue&type=template&id=291bdf34"
import script from "./EmployeePolicy.vue?vue&type=script&lang=js"
export * from "./EmployeePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports